export const validateLabelName = (name: string) => {
  return /^[\w ~`!@#$%^&*()\-_=+{}[\]|/\\:;"'<>,.?]{0,50}(\s+[^\s]+)*$/.test(name) || name === '';
};

export const validateLabelColor = (color: string) => {
  return /^[0-9a-fA-F]+$/.test(color) || color === '';
};
